const urlParams = new URLSearchParams(window.location.search);
const layoutParam = urlParams.get('layout');

if (layoutParam === 'content') {
  sessionStorage.setItem('layout', 'content');
}

export default localStorage;
